import { createContext, useContext, useState } from "react";

import UserCoursesAddModal from "@/widgets/user/user-courses-add-modal/UserCoursesAddModal";


const CourseModalContext = createContext<ICourseModalProvider>({
  openModal: () => {},
  closeModal: () => {}
})

export const CourseModalProvider = ({children}: {children: React.ReactNode}) => {
  const [isOpen, setIsOpen] = useState(false)
  const [userId, setUserId] = useState('')
  const [courseId, setCourseId] = useState('')

  const openModal = (id: string,  courseId?: string) => {
    setUserId(id)
    setIsOpen(true)
    if (courseId) {
      setCourseId(courseId)
    }
  }
  const closeModal = () => setIsOpen(false)
  return <CourseModalContext.Provider value={{closeModal, openModal}}>
    <UserCoursesAddModal 
      isOpen={isOpen}
      onClose={closeModal}
      id={userId}
      courseId={courseId}
    />
    {children}
  </CourseModalContext.Provider>
}

export const useModal = () => useContext(CourseModalContext)